import { render } from "./Success_pg.vue?vue&type=template&id=abd6e31e&scoped=true"
import script from "./Success_pg.vue?vue&type=script&lang=js"
export * from "./Success_pg.vue?vue&type=script&lang=js"

import "./Success_pg.vue?vue&type=style&index=0&id=abd6e31e&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abd6e31e"]])

export default __exports__